import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const QualityIngredientsRoot = styled('div', {
  background: '$accent-white',
  padding: '0 $2',

  '@bp2': {
    background: '$tertiary-200',
    padding: '$6 $2',
  },
})

export const QualityIngredientsContainer = styled('div', {
  maxWidth: '400px',
  margin: '0 auto',
  overflow: 'hidden',

  '@bp2': {
    maxWidth: '1200px',
  }
})

export const Headline = styled('h1', {
  fontFamily: '$display',
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  textAlign: 'center',
  marginBottom: '$5',

  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
    marginBottom: '$6',
  },
})

export const ContentRow = styled('div', {
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$4',

  '@bp2': {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '$6',
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  height: '300px',

  '@bp2': {
    width: '50%',
   height: '419px'
  },
})

export const ImageWrapper = styled('div', {
  position: 'absolute',
  top: 0,
  zIndex: 1,
  height: '275px',
  aspectRatio: '873 / 436',
  left: '50%',
  transform: 'translateX(calc(-50%))',

  '@bp2': {
    height: '436px',
    transform: 'translateX(calc(-50% - 250px))',
  }
})

export const CopyColumn = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$4',

  '@bp2': {
    width: '50%',
  },
})

export const ClaimsList = styled('ul', {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
})

export const ClaimItem = styled('li', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
})

export const ClaimText = styled(Text, {
  fontWeight: '$semiBold'
})

export const ButtonRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '$5',
})
